<template>
    <div class="vuetable-filterbar col-md-12">
        <div class="form-group p-l">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>
                    <b-col sm="6" md="2" class="p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="cd" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Código</label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="2" class="p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="name" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Nome</label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="2" class="p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="descr" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Descrição</label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="2">
                        <multiselect v-model="permission"
                        :options="optionsPermissions"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Permission"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>

                    <b-col sm="6" md="2">
                        <multiselect v-model="status"
                        :options="optionsLivStatus"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Status"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>

                    <b-col sm="6" md="2">
                        <div class="input-group-btn">
                            <div class="btn-group">
                                <button type="button" class="btn btn-secondary btn-outline" @click="doFilter" :disabled="vuetableFilterButton">Filtrar</button>
                                <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter" :disabled="vuetableFilterButton">Limpar</button>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>


<script>
export default {
  data () {
    return {
        helpForm: new Form({params: []}),
        showFilter: true,
        isDisabled: false,
        cd: '',
        name: '',
        descr: '',
        permission: '',
        optionsLivStatus: [],
        optionsPermissions: [],
        status: [],
        data_filter: []
    }
  },
  mounted() {
      this.getLivGeral();
    },
  methods: {
      doFilter () {
          this.$store.commit('setVuetableFilterButton', true);
          this.data_filter = {cd: this.cd,
                              name: this.name,
                              descr: this.descr,
                              permission: this.permission.value,
                              status: this.status.value}
          this.$events.fire('filter-set', this.data_filter);
      },
      resetFilter () {
        this.cd = '';
        this.name = '';
        this.descr = '';
        this.permission = '';
        this.status = '';
        this.$events.fire('filter-reset');
      },
      getLivGeral() {
          this.helpForm.get('/api/role/jsonlist').then(response =>
          {
              response.status.forEach((obj)=>
              {
                  this.optionsLivStatus.push({ label: obj.descr, value: obj.valor })
              });

              response.permissions.forEach((obj)=>
              {
                  this.optionsPermissions.push({ label: obj.descr, value: obj.id })
              });
          })
          .catch(errors =>
          {
              new ReturnApi(errors, this)
          });
      }
  },
  computed: {
    vuetableFilterButton: {
      get () {
        return this.$store.state.vuetable.filterButton;
      },
     },
    }
}
</script>
